// extracted by mini-css-extract-plugin
export default {"inputWrapper":"betInput_inputWrapper__mezSa","label":"betInput_label__32TQ5"};